import script from "./editMedicDoseUpper.vue?vue&type=script&setup=true&lang=ts"
export * from "./editMedicDoseUpper.vue?vue&type=script&setup=true&lang=ts"

import "./editMedicDoseUpper.vue?vue&type=style&index=0&id=18199c20&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18199c20"]])

export default __exports__